module.exports = "/assets/order-personal-details@2x.png?Cf6Sfxh";